module.exports = __webpack_public_path__ + "static/media/astronauta_fail.72808f97.svg";